import axios from 'axios';
import tools from './tools';

// List all course per university
async function listCourses(queryParams, filters, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      ...filters
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function retrieveCourse(id, queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${id}/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function createCourse(bodyData, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/`;  
  const request = axios.post(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function updateCourse(bodyData, courseId, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  courseId = courseId ? courseId : bodyData.id;
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/`;  
  const request = axios.patch(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function deleteCourse(courseId, cancelTokenParam ) {    
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/`;  
  const request = axios.delete(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}


export default {
  listCourses,
  createCourse,
  updateCourse,
  deleteCourse,
  retrieveCourse,
}